import { useState } from "preact/hooks";

// One button that puts `text` on the clipboard and says whether it worked.
// The status remembers the text it was copied from and shows only while that
// text is still the one offered, so a stale «Kopiert.» never describes another
// text; derived, not reset in an effect, because an effect also runs after the
// mount and would overwrite a status set before its first flush. The
// clipboard API needs a secure context and a user gesture; outside both it
// rejects, and the failure line tells the reader to copy by hand.
export function CopyButton({
  text,
  label,
  done,
  failed,
}: {
  text: string;
  label: string;
  done: string;
  failed: string;
}) {
  const [status, setStatus] = useState<{ text: string; ok: boolean } | null>(null);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setStatus({ text, ok: true });
    } catch {
      setStatus({ text, ok: false });
    }
  };

  const current = status && status.text === text ? status : null;
  return (
    <>
      <button type="button" class="window-pill active" onClick={() => void copy()}>
        {label}
      </button>
      {current && (
        <div class={current.ok ? "kpi-sub" : "hl-orange"} role="status">
          {current.ok ? done : failed}
        </div>
      )}
    </>
  );
}
